import _ from "lodash";

export const isInPath = (location: string, path: string): boolean => {
  var trimmed = _.trim(location, "/");
  var trimmedPath = _.trim(path, "/");
  return trimmed === trimmedPath;
};
